export const enum EProviderTabs {
  OauthClient = 13,
  ProviderSettings = 12,
  User = 11,
  History = 10,
  Depot = 9,
  Drivers_OnDemand = 8,
  Drivers = 7,
  Vehicles = 6,
  Licenses = 5,
  Documents = 4,
  Service_Area = 3,
  Fee_Schedule = 2,
  Details = 1,
}

export const enum EProviderSelectionLimits  {
  MIN_SELECTED = 2
};



// WEBPACK FOOTER //
// ./src/app/core/enums/provider-tabs.enum.ts